import './SDGsImpactField.css';

import React, {  } from 'react';
import FieldComponent from '../../../b2b-common/FieldComponent';
import useB2BTranslation from '../../../b2b-common/hooks/useB2BTranslation';
import { generateClassName } from '../../../b2b-common/helpers';
import { FwRelated } from '../../../b2b-plans/components/FwsRelated';

const SDGsImpactField = ({ sdgs2030,  sdgsCount = 20, className = null }) => {
    const { t } = useB2BTranslation('b2b-frameworks');
    if (!sdgs2030 || !sdgs2030.level1sDTOs || sdgs2030.level1sDTOs.length === 0) {
        return null;
    }

    return (
        <FieldComponent
            label={t('SDGs Impact')}
            component={
                <FwRelated
                    framework={sdgs2030}
                    showLogo={false}
                    iconsSize={24}
                    level1sNumber={sdgsCount}
                />                
            }
            className={generateClassName('sdgs-impact-field', '', className)}
            labelAlign='left'
            componentAlign='left'
        />
    );
};

export default SDGsImpactField;